import FeatureFlags from "@/classes/FeatureFlags";
import { API } from "@/services/apiInstance";

// Singleton FeatureFlags instance. Depends on `API` so it loads after
// `apiInstance.js`. The `FeatureFlags` class itself has no app-internal
// imports (only Vue's `reactive`), so this chain has no upward deps.
export const featureFlags = new FeatureFlags(API);
